// v2 API configuration — single source for the new server namespace.
//
// IMPORTANT: the server did NOT ship a `/api/v2` prefix. Per its own
// revamp_server.md (architecture decision #2), the legacy tree was parked
// (routes/api -> routes/api_old) and the NEW API was built in the clean
// `/api/*` namespace. So the new client points at plain `/api` — that IS the
// new server. (This supersedes revamp_ui.md's `/api/v2` references.)
//
// base_url resolves per-env from src/environment/url.js:
//   dev  -> 'http://localhost:5050/api'      => API_BASE 'http://localhost:5050/api'
//   prod -> process.env.REACT_APP_BASE_URL   => API_BASE `${REACT_APP_BASE_URL}`
import { base_url } from '../environment/url';
import { stripe_pk } from '../environment/keys';

export const API_BASE = base_url;

// Reuse the existing Stripe publishable key (brand/account unchanged).
export const STRIPE_PK = stripe_pk;
